import { Box, Link, Image } from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';

const getLoginUrl = (redirectUrl: string) => {
  return `/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
};

function SpecialSideLoginBanner({ redirectUrl }: { redirectUrl: string }) {
  return (
    <Box _hover={{ opacity: '0.8' }}>
      <Link
        href={getLoginUrl(redirectUrl)}
        onClick={() => sendAnalyticsEvent('special_contents', 'click', 'login')}
      >
        <Image
          src="/images/special/special_side_login.png"
          alt="ログインまたは新規登録"
          width={720}
          height="auto"
        />
      </Link>
    </Box>
  );
}

export default SpecialSideLoginBanner;
